import * as Immutable from "immutable";
import URI from "urijs";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Users } from "@graylog/server-api";
import UserOverview from "logic/users/UserOverview";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import User from "logic/users/User";
export const USERS_QUERY_KEY = ["users"];
const usersUrl = ({ url = "", query = {} }) => {
  const uri = new URI(url);
  uri.query(query);
  return qualifyUrl(uri.resource());
};
export const createUser = (user) => {
  const url = qualifyUrl(ApiRoutes.UsersApiController.create().url);
  return fetch("POST", url, user);
};
export const loadUser = (id) => {
  const url = qualifyUrl(ApiRoutes.UsersApiController.load(encodeURIComponent(id)).url);
  return fetch("GET", url).then(User.fromJSON);
};
export const loadUserByUsername = (username) => {
  const url = qualifyUrl(ApiRoutes.UsersApiController.loadByUsername(encodeURIComponent(username)).url);
  return fetch("GET", url).then(User.fromJSON);
};
export const updateUser = (userId, request) => {
  const url = qualifyUrl(ApiRoutes.UsersApiController.update(encodeURIComponent(userId)).url);
  return fetch("PUT", url, request);
};
export const deleteUser = (userId) => Users.deleteUserById(encodeURIComponent(userId));
export const changeUserPassword = (userId, request) => Users.changePassword(encodeURIComponent(userId), request);
export const createUserToken = (userId, tokenName, tokenTtl) => {
  const url = qualifyUrl(
    ApiRoutes.UsersApiController.create_token(encodeURIComponent(userId), encodeURIComponent(tokenName)).url
  );
  return fetch("POST", url, { token_ttl: tokenTtl });
};
export const loadUserTokens = (userId) => {
  const url = qualifyUrl(ApiRoutes.UsersApiController.list_tokens(encodeURIComponent(userId)).url);
  return fetch("GET", url).then((response) => response.tokens);
};
export const deleteUserToken = (userId, tokenId) => Users.revokeToken(encodeURIComponent(userId), encodeURIComponent(tokenId));
export const loadUsers = (query = {}) => {
  const url = usersUrl({ url: ApiRoutes.UsersApiController.list().url, query });
  return fetch("GET", url).then(
    ({ users }) => Immutable.List(users.map((user) => UserOverview.fromJSON(user)))
  );
};
export const loadUsersPaginated = ({ page, perPage, query }) => Users.getPage(void 0, page, perPage, query).then((response) => {
  var _a;
  return {
    adminUser: ((_a = response.context) == null ? void 0 : _a.admin_user) ? UserOverview.fromJSON(response.context.admin_user) : void 0,
    list: Immutable.List(response.users.map((user) => UserOverview.fromJSON(user))),
    pagination: {
      page: response.page,
      perPage: response.per_page,
      query: response.query,
      count: response.count,
      total: response.total
    }
  };
});
export const setUserStatus = (userId, accountStatus) => {
  const url = qualifyUrl(ApiRoutes.UsersApiController.setStatus(userId, accountStatus).url);
  return fetch("PUT", url);
};
export const useUsers = (query = {}) => useQuery({
  queryKey: [...USERS_QUERY_KEY, "overview", query],
  queryFn: () => loadUsers(query)
});
export const useUsersPaginated = (pagination) => useQuery({
  queryKey: [...USERS_QUERY_KEY, "paginated", pagination],
  queryFn: () => loadUsersPaginated(pagination),
  placeholderData: keepPreviousData
});
